import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import * as _ from "lodash";
import { BackendService } from '../../core/services/backend/backend.service';
import { take } from 'rxjs';

export interface ILevelRating{
  level: number,
  rating: number
}

export interface IRating{
  typeId: number,
  levels: Array<ILevelRating>
}

@Injectable({
  providedIn: 'root'
})
export class ProgressPlayerHelper {

  allProgress: Array<IRating> = [];
  progress:IRating;
  objectProgress: Object = {};

  http = inject(HttpClient);
  backend = inject(BackendService);

  parseObjectToArray(){
    // let progress = {
    //   15:{1:75,2:55,3:100},
    //   5:{1:45}
    // }

    this.allProgress = Object.keys(this.objectProgress).map(key => ({
      typeId: parseInt(key),
      // @ts-ignore
      levels: Object.keys(this.objectProgress[key]).map((item, index) =>({
        level: (index+1),
        // @ts-ignore
        rating: this.objectProgress[key][item]
      }))
    }));
  }

  parseObjectToArrayGetBack(cardsByDifficulty: any){
    return Object.keys(cardsByDifficulty).map(key => ({
      typeId: parseInt(key),
      // @ts-ignore
      levels: Object.keys(cardsByDifficulty[key]).map((item, index) =>({
        level: (index+1),
        // @ts-ignore
        rating: cardsByDifficulty[key][item]
      }))
    }));
  }

  parseArrayToObject(){
    // const obj: any = {};
    // let arr = [{"typeId": 5,"levels": [{"level": 1,"rating": 45}]},{"typeId": 15,"levels": [{"level": 1,"rating": 75},{"level": 2,"rating": 55},{"level": 3,"rating": 100}]}];
    // TODO arr => progress
    // this.allProgress.forEach((item:any)=>{
    //   // @ts-ignore
    //   this.objectProgress[item.typeId] = item.levels.reduce((accumulator: any, current:any)=>{
    //     accumulator[current.level] = current.rating;
    //     return accumulator;
    //   },{});
    // });

    this.allProgress.forEach((item:any)=>{
      // @ts-ignore
      this.objectProgress[item.typeId] = item.levels.reduce((accumulator: any, current:any)=>{
        return accumulator.concat(current.rating)
      },[]);
    });
    
  }

  saveStorage(){
    this.http.post(`${this.backend.getApiUrl()}/profile/progress`,{progress: this.objectProgress}).pipe(
        take(1)
      ).subscribe((result:any)=>{
        sessionStorage.setItem('progress', JSON.stringify(this.objectProgress));
      });
  }

  getWithStorage(){
    if(sessionStorage.getItem('progress')){
      this.objectProgress = JSON.parse(sessionStorage.getItem('progress') as string);
      this.parseObjectToArray();
    }else{
      this.http.get(`${this.backend.getApiUrl()}/profile/progress`).pipe(
        take(1)
      ).subscribe((result:any)=>{
        if(!_.isEmpty(result.progress)){
          this.objectProgress = result.progress;
          sessionStorage.setItem('progress', JSON.stringify(this.objectProgress));
          this.parseObjectToArray();
        }
      });
    }
  }

  setProgress(typeId: number, progress: number, level: number){
    this.findType(typeId);
    if(_.isEmpty(this.progress)){
      this.addNewProgress(typeId, progress, level);
    }else{
      if( !_.isEmpty(this.findLevel(level)) ){
        this.update(progress, level);
      }else{
        this.addLevel(progress, level);
      }
    }
    
  }

  addNewProgress(typeId: number, progress: number, level: number){
      let levels: Array<ILevelRating> = [];
  
      levels.push({
        level,
        rating: progress
      });
  
      this.allProgress.push({
        typeId,
        levels: levels
      });
  }

  addLevel(progress: number, level: number){
    this.progress.levels.push({
      level: level,
      rating: progress
    });
  }

  update(progress: number, level: number){
    this.progress.levels.forEach(item =>{
      if(item.level === level){
        item.rating = progress;
      }
    });
  }

  findType(typeId: number){
    this.progress = this.allProgress.find(item => item.typeId === typeId) as IRating ?? [];
  }
  
  findLevel(level: number){
    let res:any = [];
    if(!_.isEmpty(this.progress)){
        res = this.progress.levels.find(item => item.level === level) ?? [];
    }
    return res;
  }

  clearProgress(){
    this.allProgress = [];
    sessionStorage.removeItem('progress');
  }
  
}
